module.exports = __webpack_public_path__ + "static/media/persona_6.fe3b2c05.png";